import { useCallback } from 'react';
import { useTokenizationRequest } from './useTokenizationRequest';

export enum TransactionAmountType {
  FINAL = 'FINAL',
  ESTIMATED = 'ESTIMATED',
  NOT_CURRENTLY_KNOWN = 'NOT_CURRENTLY_KNOWN',
}

type EncryptedWalletRequest = {
  transactionAmountType: TransactionAmountType;
  applePayPaymentData: unknown;
  address_line1?: string;
  address_zip?: string;
};

export function usePostApplePayToken() {
  const [,postApplePayTokenImpl] = useTokenizationRequest((event: ApplePayJS.ApplePayPaymentAuthorizedEvent) => {
    const { token: { paymentData: applePayPaymentData }, billingContact = {} } = event.payment;
    const { addressLines = [], postalCode } = billingContact;

    const encryptedWallet: EncryptedWalletRequest = {
      transactionAmountType: TransactionAmountType.ESTIMATED,
      applePayPaymentData,
      ...(addressLines.length > 0 && { address_line1: addressLines[0] }),
      ...(postalCode !== undefined && { address_zip: postalCode }),
    };

    return ({
      method: 'POST',
      url: '/v1/tokens',
      data: { encryptedWallet },
    });
  });

  const postApplePayToken = useCallback(async (event: ApplePayJS.ApplePayPaymentAuthorizedEvent) => {
    const response = await postApplePayTokenImpl<{id: string}>(event);

    if (!response?.id) return;

    return response.id;

  }, [postApplePayTokenImpl]);

  return {
    postApplePayToken
  };
}
